import { createSelector } from 'reselect'

import { selectPartnerSearchState } from './selectPartnerSearchState'

export const selectContactsDataState = createSelector(
  [selectPartnerSearchState],
  ({ contacts }) => contacts
)
